module.exports = __webpack_public_path__ + "media/images/thumbs/quizassignment/ohap_quiz thumbnail_64-9b2da239c29a4954d1fcd574881e45c9.jpg";